export type NewsItem = {
  id: string;
  title: string;
  category: string;
  author: string;
  publishDate: string;
  views: number;
  cover: string;
  excerpt: string;
  body: string[];
  tags: string[];
};

export const newsCategories = [
  "全部",
  "资讯动态",
  "行业报道",
  "健康知识",
  "文化观察",
];

const news1 =
  "https://readdy.ai/api/search-image?query=Modern%20smartphone%20on%20a%20dark%20desk%20with%20warm%20lamp%20light%20and%20abstract%20privacy%20themed%20background%2C%20editorial%20technology%20still%20life%2C%20burgundy%20tones%2C%20high%20detail&width=480&height=300&seq=adult-news-01&orientation=landscape";
const news2 =
  "https://readdy.ai/api/search-image?query=Stack%20of%20vintage%20film%20reels%20and%20a%20clapperboard%20on%20a%20dark%20wooden%20table%2C%20warm%20amber%20light%2C%20editorial%20still%20life%2C%20high%20detail&width=480&height=300&seq=adult-news-02&orientation=landscape";
const news3 =
  "https://readdy.ai/api/search-image?query=Person%20silhouette%20reading%20a%20tablet%20in%20a%20dark%20room%20late%20at%20night%2C%20warm%20screen%20glow%2C%20cinematic%20editorial%20photography%2C%20high%20detail&width=480&height=300&seq=adult-news-03&orientation=landscape";
const news4 =
  "https://readdy.ai/api/search-image?query=Old%20cinema%20seats%20in%20a%20dark%20empty%20theater%20with%20warm%20aisle%20lighting%2C%20cinematic%20wide%20shot%2C%20burgundy%20upholstery%2C%20high%20detail&width=480&height=300&seq=adult-news-04&orientation=landscape";
const news5 =
  "https://readdy.ai/api/search-image?query=Independent%20filmmaker%20desk%20with%20camera%20lens%20and%20notebook%20in%20warm%20lamp%20light%2C%20dark%20moody%20editorial%20still%20life%2C%20high%20detail&width=480&height=300&seq=adult-news-05&orientation=landscape";
const news6 =
  "https://readdy.ai/api/search-image?query=Laptop%20with%20security%20lock%20concept%20on%20dark%20desk%20with%20amber%20light%2C%20editorial%20technology%20photography%2C%20burgundy%20background%2C%20high%20detail&width=480&height=300&seq=adult-news-06&orientation=landscape";

export const newsArticles: NewsItem[] = [
  {
    id: "n1",
    title: "成人内容平台的隐私保护，正在成为新的竞争点",
    category: "行业报道",
    author: "编辑部 · 陆沉",
    publishDate: "2026-10-12",
    views: 8420,
    cover: news1,
    excerpt:
      "当观看行为本身变成敏感数据，平台如何在推荐效率与用户隐私之间找到平衡？我们采访了三位从业者，聊了聊他们的做法。",
    body: [
      "过去两年，用户对隐私的关注度明显上升。多项海外调研显示，超过六成的受访者表示，在选择平台时会优先考虑“是否收集过多个人信息”，这一比例已经接近内容质量本身。",
      "几家平台的做法值得参考：默认关闭观看历史的云端同步、把推荐模型放在本地完成、以及在注册环节尽量只保留必要字段。一位产品负责人提到，他们内部把这种做法称为“最小可见原则”——系统只需要知道你想看什么，不需要知道你是谁。",
      "当然，隐私保护与推荐效果之间存在天然的张力。更少的用户数据意味着更难做精准推荐，平台需要靠更好的内容标签体系来弥补。这也让“人工编辑 + 分类标签”的模式重新回到讨论中心。",
      "对普通用户来说，最实用的建议依然是那几条：使用独立的邮箱、定期清理浏览记录、不要在站内填写真实姓名和常用手机号。保护自己，从来不需要等待平台先做到完美。",
    ],
    tags: ["隐私", "数据", "平台治理"],
  },
  {
    id: "n2",
    title: "内容分级制度再讨论：平台该承担多少责任",
    category: "资讯动态",
    author: "编辑部 · 江弥",
    publishDate: "2026-10-08",
    views: 6120,
    cover: news2,
    excerpt:
      "分级不是一张标签，而是一整套流程。从上传审核到推荐分发，平台的责任边界正在被重新划定。",
    body: [
      "关于内容分级的讨论每隔一段时间就会回到公众视野。支持者认为，清晰的分级能让成年人获得更顺畅的体验，也能更有效地保护未成年人；反对者则担心，分级标签反而会让边界内容更容易被检索。",
      "从执行层面看，分级真正困难的地方不在标注，而在流程：谁来审、多久复审一次、用户举报后如何响应、推荐系统是否会放大边缘内容。这些问题没有标准答案，但每一家平台都必须给出自己的答案。",
      "值得注意的是，越来越多的平台开始把“18+ 确认”做成一次性的轻量提示，而不是反复打断观看流程的弹窗。这种设计上的克制，本身也是一种对用户体验的尊重。",
    ],
    tags: ["分级", "合规", "审核"],
  },
  {
    id: "n3",
    title: "长期夜间观看屏幕，如何保护你的睡眠与视力",
    category: "健康知识",
    author: "特约作者 · 沈医生",
    publishDate: "2026-10-03",
    views: 11360,
    cover: news3,
    excerpt:
      "暗环境 + 高亮度屏幕，是眼睛最不喜欢的组合。几个简单可执行的调整，能明显降低夜间观看的负担。",
    body: [
      "夜间观看时，环境光与屏幕亮度的差距越大，眼睛的调节负担就越重。最简单的做法是保留一盏低亮度的背景灯，避免在全黑环境中直视屏幕。",
      "第二个建议是开启设备的暖色模式，并适当降低屏幕亮度。蓝光对睡眠节律的影响已经被反复验证，睡前两小时把色温调暖，入睡会明显容易一些。",
      "第三个建议与姿势有关。长时间半躺观看会让颈部肌肉持续紧张，建议每隔四十分钟起身活动一次，把手机或平板抬高到接近视线平行的位置。",
      "最后一点常被忽略：控制总时长。任何护眼设置都无法抵消连续三小时的疲劳，定时提醒比任何硬件功能都更有效。",
    ],
    tags: ["健康", "睡眠", "用眼"],
  },
  {
    id: "n4",
    title: "从录像厅到流媒体：成人影像的四十年",
    category: "文化观察",
    author: "专栏 · 周野",
    publishDate: "2026-09-25",
    views: 9280,
    cover: news4,
    excerpt:
      "载体在变，观看的空间也在变。从公共录像厅到私人屏幕，这段历史其实是一部关于“私密性”的技术史。",
    body: [
      "上世纪八十年代，录像厅是一种半公共的观看空间。人们挤在同一间屋子里，共享同一块屏幕，那种体验带着某种集体的隐秘感。",
      "家用录像机和有线电视的出现，把观看行为第一次完整地搬回了客厅。到了互联网时代，观看彻底变成一件个人的事，屏幕越来越小，选择越来越多。",
      "有意思的是，近两年“一起看”的功能重新流行起来。同步播放、语音房间、弹幕评论，技术又把分散的观众重新连接成临时的共同体。",
      "四十年过去，唯一没有改变的是：内容始终在寻找更适合它的观看方式。",
    ],
    tags: ["历史", "媒介", "文化"],
  },
  {
    id: "n5",
    title: "独立制片者的新渠道：订阅制带来什么",
    category: "行业报道",
    author: "编辑部 · 陆沉",
    publishDate: "2026-09-17",
    views: 4870,
    cover: news5,
    excerpt:
      "当平台开始按观看时长分成，短篇与实验作品是否有机会获得更公平的曝光？几位独立创作者给出了他们的观察。",
    body: [
      "订阅制并不是新事物，但按观看时长分成，确实改变了一部分创作者的策略。过去追求单次点击的标题党做法，在长尾分成模型下收益有限。",
      "多位受访者提到，作品的前三十秒变得更重要了——不是因为它决定点击，而是因为它决定观众是否愿意留下来。节奏、光线、声音，这些“慢变量”重新被重视。",
      "另一方面，订阅制也带来了新的压力：稳定的更新频率成为硬指标。对只有两三个人的小团队来说，这往往比创作本身更消耗精力。",
    ],
    tags: ["独立制片", "订阅", "创作者"],
  },
  {
    id: "n6",
    title: "如何设置更安全的账号与支付方式",
    category: "健康知识",
    author: "编辑部 · 江弥",
    publishDate: "2026-09-06",
    views: 7310,
    cover: news6,
    excerpt:
      "独立密码、独立邮箱、可控的支付方式——三件小事，能挡住绝大多数账号风险。",
    body: [
      "第一条原则是账号隔离。用一个专门的邮箱注册这类平台，不要与工作邮箱、社交账号混用，可以在出现问题时迅速切断关联。",
      "第二条是密码管理。为每个站点设置不同的密码，听上去麻烦，但借助密码管理器其实只需要记住一个主密码。",
      "第三条与支付有关。尽量使用可限额的虚拟卡或平台内的代币，不要绑定主力的银行卡，也不要在站内保存完整的支付信息。",
      "最后，注意那些要求你提供身份证照片或人脸识别的页面。在没有明确说明用途与保存期限的情况下，谨慎为上。",
    ],
    tags: ["安全", "账号", "支付"],
  },
];

export const featuredNews = newsArticles.slice(0, 3);